import { ISidebarNavigation } from "@/api/types/helpers/types";
import DepartmentSwitcher from "@/components/custom-ui/sidebar/department.switcher";
import MainNavGroup from "@/components/custom-ui/sidebar/main.nav.group";
import { NavUser } from "@/components/custom-ui/sidebar/nav.user";
import SecondaryNavGroup from "@/components/custom-ui/sidebar/secondary.nav.group";
import ServicesNavGroup from "@/components/custom-ui/sidebar/services.nav.group";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from "@/components/ui/sidebar";
import { useUserStore } from "@/store/user";

const AppSidebar = ({
  navigationLinks,
  ...props
}: { navigationLinks: ISidebarNavigation } & React.ComponentProps<typeof Sidebar>) => {
  const user = useUserStore((store) => store.user);
  return (
    <Sidebar collapsible="icon" variant="sidebar" side="left" {...props}>
      <SidebarHeader>
        <DepartmentSwitcher />
      </SidebarHeader>
      <SidebarContent>
        {navigationLinks.main && navigationLinks.main.length > 0 && (
          <MainNavGroup mainMenuItems={navigationLinks.main} user={user} />
        )}
        {navigationLinks.services && navigationLinks.services.length > 0 && (
          <ServicesNavGroup servicesMenuItems={navigationLinks.services} user={user} />
        )}
        {navigationLinks.secondary && navigationLinks.secondary.length > 0 && (
          <SecondaryNavGroup
            className="mt-auto"
            secondaryMenuItems={navigationLinks.secondary}
            user={user}
          />
        )}
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={user} />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
};

export default AppSidebar;
